var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScreenshare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.935,
    height: 31.798,
    viewBox: "0 0 37.935 31.798",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6797",
    "data-name": "Group 6797",
    transform: "translate(723.339 1750.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_277",
    "data-name": "Path 277",
    d: "M-501.292-1459.8Z",
    transform: "translate(-202.448 -265.128)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_278",
    "data-name": "Path 278",
    d: "M-699.614-1723.836v3.3c.9,0,1.767-.005,2.635,0,.977.007,1.4.326,1.414,1.049.014.739-.393,1.063-1.369,1.063q-7.424,0-14.848,0c-1.017,0-1.377-.279-1.374-1.042,0-.738.414-1.062,1.382-1.071.848-.008,1.7,0,2.611,0v-3.3h-.893q-5.491,0-10.982,0a2.018,2.018,0,0,1-2.3-2.315q-.006-10.85,0-21.7a2.072,2.072,0,0,1,2.3-2.361q16.649-.013,33.3,0a2.073,2.073,0,0,1,2.328,2.336q.014,10.894,0,21.788a1.975,1.975,0,0,1-2.263,2.252q-5.447.008-10.894,0Zm11.744-23.906h-32.917v19.584h32.917Zm-16.464,20.507a1.136,1.136,0,0,0-1.186,1.08,1.141,1.141,0,0,0,1.141,1.189,1.072,1.072,0,0,0,1.1-1.124A1.071,1.071,0,0,0-704.334-1727.235Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_279",
    "data-name": "Path 279",
    d: "M-572.972-1668.634l-4.431,4.226a2.218,2.218,0,0,1-.383.356.776.776,0,0,1-.509.134c-.1-.027-.183-.281-.186-.435-.018-.814-.009-1.629-.009-2.5a8.115,8.115,0,0,0-3.565.486,7.976,7.976,0,0,0-4.2,3.354c-.042.066-.068.152-.126.194-.173.124-.358.232-.538.345a2.262,2.262,0,0,1-.192-.6,2.247,2.247,0,0,1,.128-.683c.878-3.07,2.588-5.426,5.734-6.47a24.177,24.177,0,0,1,2.791-.581c0-.706-.018-1.463.011-2.217a2.411,2.411,0,0,1,.225-.659,2.418,2.418,0,0,1,.636.307c1.4,1.3,2.778,2.615,4.168,3.922a5.376,5.376,0,0,0,.45.345Z",
    transform: "translate(-124.357 -69.877)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshare);
export default __webpack_public_path__ + "static/media/Screenshare.52c1f78e1c7eea3232eeff2373509cc6.svg";
export { ForwardRef as ReactComponent };